import { getPartnerOtcCatalogApi } from 'api/partner';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useFormState } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { handleError } from 'store/thunks/errorHandlerThunks';

const otcItemsContext = createContext(null);

// The partner's OTC catalog comes back in API order; the picker offers it A–Z as it reads.
const otcLabel = (item) => `${item?.name ?? ''} ${item?.strength ?? ''}`;
const sortOtcItems = (items) =>
  [...(items || [])].sort((left, right) =>
    otcLabel(left).localeCompare(otcLabel(right), undefined, { sensitivity: 'base', numeric: true })
  );

export const OTCItemsListProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [otcItems, setOtcItems] = useState([]);
  const formState = useFormState();

  useEffect(() => {
    if (formState.values.partnerId) {
      getPartnerOtcCatalogApi({ partnerUuid: formState.values.partnerId })
        .then((items) => setOtcItems(sortOtcItems(items)))
        .catch((error) => dispatch(handleError({ error })));
    } else {
      setOtcItems([]);
    }
  }, [dispatch, formState.values.partnerId]);

  const memoizedValue = useMemo(
    () => ({
      otcItems,
    }),
    [otcItems]
  );

  return <otcItemsContext.Provider value={memoizedValue}>{children}</otcItemsContext.Provider>;
};

OTCItemsListProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

const useOtcItemsList = () => useContext(otcItemsContext);

export default useOtcItemsList;
